import React from 'react';
import Popup from 'reactjs-popup';
import ExportViewWrap from '../import/ExportViewWrap';

const ExportView_Popup = ({ _WaveformView }) => {
  function NumberList(props) {
    const error = props.error;
    const listItems = error.map((obj, index) => {
      const { rowIndex, typeName, errorMessage } = obj;

      return (
        <li key={index.toString()}>
          <a
            onClick={() => {
              //moveCellSelect(index);
            }}
          >
            {' '}
            Line {rowIndex + 1} {errorMessage}
          </a>
        </li>
      );
    });

    return <ul>{listItems}</ul>;
  }

  return (
    <Popup
      open={_WaveformView.state.isShowExportView}
      modal
      closeOnDocumentClick
      onClose={() => {
        _WaveformView.setState({ isShowExportView: false });
      }}
      contentStyle={{ width: '600px' }}
    >
     <ExportViewWrap _WaveformView={_WaveformView} />
    </Popup>
  );
};

export default ExportView_Popup;



// WEBPACK FOOTER //
// ./src/components/popup/ExportView_Popup.js